export const zoomCircleSize = "12vmax";
